<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="cancelZone">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew" @click.prevent="deleteZone" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate" :title="$t('general.saveChanges')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                 <div class="form-group">
                  <p>ID: {{model.id}}</p>
                </div>
                <div class="form-group">
                  <label>Group Name</label>
                  <input type="text"
                          name="group_name"
                          data-vv-as="Group Name"
                          placeholder="Group Name"
                          v-validate="model.gateway === 'btIpay' ? {required: true} : modelValidate.group_name"
                          v-model="model.group_name"
                          class="form-control">
                  <small class="text-danger" v-if="errors.has('group_name')">
                    {{ getError('group_name') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>Gateway</label>
                  <select name="location" class="form-control"
                                v-validate="modelValidate.gateway"
                                v-model="model.gateway"
                                @change="changeGateway()">
                    <option v-for="(loc) in locations"
                                :value="loc"
                                :label="loc"
                                :key="loc">
                    </option>
                  </select>
                </div>

                <template v-if="model.gateway === 'btIpay'">
                  <p v-if="btFormError" class="text-danger" role="alert">{{btFormError}}</p>
                  <div class="form-group">
                    <label for="bt-api-user">{{$t('btPayments.apiUser')}}</label>
                    <input id="bt-api-user" name="bt_api_user" type="text" class="form-control" autocomplete="off" maxlength="30" v-model="model.bt_ipay_data.api_user" v-validate="{required: true, max: 30}">
                    <small class="text-danger">{{getError('bt_api_user')}}</small>
                  </div>
                  <div class="form-group">
                    <label for="bt-api-password">{{$t('btPayments.apiPassword')}}</label>
                    <input id="bt-api-password" name="bt_api_password" type="password" class="form-control" autocomplete="new-password" maxlength="30" v-model="model.bt_ipay_data.api_password" v-validate="{required: !model.bt_ipay_data.has_api_password, max: 30}">
                    <small class="text-danger">{{getError('bt_api_password')}}</small>
                    <p v-if="model.bt_ipay_data.has_api_password" class="help-block">{{$t('btPayments.passwordConfigured')}}</p>
                  </div>
                  <div class="form-group">
                    <label for="bt-environment">{{$t('btPayments.environment')}}</label>
                    <select id="bt-environment" class="form-control" v-model="model.bt_ipay_data.environment">
                      <option value="sandbox">{{$t('btPayments.sandbox')}}</option>
                      <option value="production">{{$t('btPayments.production')}}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="bt-payment-mode">{{$t('btPayments.mode')}}</label>
                    <select id="bt-payment-mode" class="form-control" v-model="model.bt_ipay_data.payment_type">
                      <option value="1phase">{{$t('btPayments.onePhase')}}</option>
                      <option value="2phase">{{$t('btPayments.twoPhase')}}</option>
                    </select>
                    <p class="help-block">{{$t('btPayments.modeHelp')}}</p>
                    <p class="help-block">{{$t('btPayments.captureHelp')}}</p>
                  </div>
                </template>

                <template v-if="model.gateway == 'euplatesc'">
                  <div class="form-group">
                    <label>Gateway ID</label>
                    <input type="text"
                            name="gateway_id"
                            data-vv-as="Gateway ID"
                            placeholder="Gateway ID"
                            v-validate="modelValidate.gateway_id"
                            v-model="model.gateway_id"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('gateway_id')">
                      {{ getError('gateway_id') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Public Key</label>
                    <input type="text"
                            name="public_key"
                            data-vv-as="Public Key"
                            placeholder="Public Key"
                            v-validate="modelValidate.public_key"
                            v-model="model.public_key"
                            disabled
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('public_key')">
                      {{ getError('public_key') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Private Key</label>
                    <input type="text"
                            name="private_key"
                            data-vv-as="Private Key"
                            placeholder="Private Key"
                            v-validate="modelValidate.private_key"
                            v-model="model.private_key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('private_key')">
                      {{ getError('private_key') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>UKEY</label>
                    <input type="text"
                            name="UKEY"
                            data-vv-as="UKEY"
                            placeholder="UKEY"
                            v-validate="modelValidate.UKEY"
                            v-model="model.UKEY"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('UKEY')">
                      {{ getError('UKEY') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>UAPI</label>
                    <input type="text"
                            name="UAPI"
                            data-vv-as="UAPI"
                            placeholder="UAPI"
                            v-validate="modelValidate.UAPI"
                            v-model="model.UAPI"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('UAPI')">
                      {{ getError('UAPI') }}
                    </small>
                  </div>
                </template>

                <template v-if="model.gateway == 'paylike'">
                  <div class="form-group">
                    <label>Gateway ID</label>
                    <input type="text"
                            name="gateway_id"
                            data-vv-as="Gateway ID"
                            placeholder="Gateway ID"
                            v-validate="modelValidate.gateway_id"
                            v-model="model.gateway_id"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('gateway_id')">
                      {{ getError('gateway_id') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Public Key</label>
                    <input type="text"
                            name="public_key"
                            data-vv-as="Public Key"
                            placeholder="Public Key"
                            v-validate="modelValidate.public_key"
                            v-model="model.public_key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('public_key')">
                      {{ getError('public_key') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Private Key</label>
                    <input type="text"
                            name="private_key"
                            data-vv-as="Private Key"
                            placeholder="Private Key"
                            v-validate="modelValidate.private_key"
                            v-model="model.private_key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('private_key')">
                      {{ getError('private_key') }}
                    </small>
                  </div>
                </template>

                <template v-if="model.gateway == 'stripe'">
                  <div class="form-group">
                    <label>Gateway ID</label>
                    <input type="text"
                            name="gateway_id"
                            data-vv-as="Gateway ID"
                            placeholder="Gateway ID"
                            v-validate="modelValidate.gateway_id"
                            v-model="model.gateway_id"
                            disabled 
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('gateway_id')">
                      {{ getError('gateway_id') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Public Key</label>
                    <input type="text"
                            name="public_key"
                            data-vv-as="Public Key"
                            placeholder="Public Key"
                            v-validate="modelValidate.public_key"
                            v-model="model.public_key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('public_key')">
                      {{ getError('public_key') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Private Key</label>
                    <input type="text"
                            name="private_key"
                            data-vv-as="Private Key"
                            placeholder="Private Key"
                            v-validate="modelValidate.private_key"
                            v-model="model.private_key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('private_key')">
                      {{ getError('private_key') }}
                    </small>
                  </div>
                </template>

                <template v-if="model.gateway == 'vivaWallet'">
                  <div class="form-group">
                    <label>Public Key</label>
                    <input type="text"
                            name="public_key"
                            data-vv-as="Public Key"
                            placeholder="Public Key"
                            v-validate="modelValidate.public_key"
                            v-model="model.public_key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('public_key')">
                      {{ getError('public_key') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Private Key</label>
                    <input type="text"
                            name="private_key"
                            data-vv-as="Private Key"
                            placeholder="Private Key"
                            v-validate="modelValidate.private_key"
                            v-model="model.private_key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('private_key')">
                      {{ getError('private_key') }}
                    </small>
                  </div>
                </template>

                <template v-if="model.gateway == 'libraPay'">
                  <div class="form-group">
                    <label>Merchant Name</label>
                    <input type="text"
                            name="merch_name"
                            data-vv-as="Merchant Name"
                            placeholder="Merchant Name"
                            v-validate="modelValidate.merch_name"
                            v-model="model.libra_pay_data.merch_name"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('merch_name')">
                      {{ getError('merch_name') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Merchant URL</label>
                    <input type="text"
                            name="merch_url"
                            data-vv-as="Merchant URL"
                            placeholder="Merchant URL"
                            v-validate="modelValidate.merch_url"
                            v-model="model.libra_pay_data.merch_url"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('merch_url')">
                      {{ getError('merch_url') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <input type="text"
                            name="email"
                            data-vv-as="Email"
                            placeholder="Email"
                            v-validate="modelValidate.email"
                            v-model="model.libra_pay_data.email"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('email')">
                      {{ getError('email') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Key</label>
                    <input type="text"
                            name="key"
                            data-vv-as="Key"
                            placeholder="Key"
                            v-validate="modelValidate.key"
                            v-model="model.libra_pay_data.key"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('key')">
                      {{ getError('key') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Merchant</label>
                    <input type="text"
                            name="merchant"
                            data-vv-as="Merchant"
                            placeholder="Merchant"
                            v-validate="modelValidate.merchant"
                            v-model="model.libra_pay_data.merchant"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('merchant')">
                      {{ getError('merchant') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Terminal</label>
                    <input type="text"
                            name="terminal"
                            data-vv-as="Terminal"
                            placeholder="Terminal"
                            v-validate="modelValidate.terminal"
                            v-model="model.libra_pay_data.terminal"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('terminal')">
                      {{ getError('terminal') }}
                    </small>
                  </div>
                  <div class="form-group">
                    <label>Post Action</label>
                    <input type="text"
                            name="postAction"
                            data-vv-as="Post Action"
                            placeholder="Post Action"
                            v-validate="modelValidate.postAction"
                            v-model="model.libra_pay_data.postAction"
                            class="form-control">
                    <small class="text-danger" v-if="errors.has('postAction')">
                      {{ getError('postAction') }}
                    </small>
                  </div>
                </template>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {btSettings, btApiError} from 'src/utils/btPayments'
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      paymentGroupId: null,
      callback: {
        required: false
      },
      route: {
        type: Object,
        default: () => ({})
      }
    },
    watch: {
      paymentGroupId (value) {
        this.id = value
      }
    },
    created () {
      console.log('route', this.route)
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    data () {
      return {
        apiUrl: '',
        btFormError: '',
        id: this.value || this.paymentGroupId,
        isNew: true,
        model: {
          'id': 0,
          'name': '',
          'bt_ipay_data': btSettings(),
          'libra_pay_data': {
            'merch_name': '',
            'merch_url': '',
            'email': '',
            'key': '',
            'merchant': '',
            'terminal': '',
            'postAction': ''
          }
        },
        modelValidate: {
          name: {required: true},
          // firstname: {required: true, min: 3},
          merch_name: {required: true},
          merch_url: {required: true},
          email: {required: true},
          key: {required: true},
          merchant: {required: true},
          postAction: {required: true}
        },
        locations: ['btIpay', 'euplatesc', 'paylike', 'stripe', 'vivaWallet', 'libraPay'],
        languages: this.$session.get('defaultData')['available_languages'],
        loading: true
      }
    },
    methods: {
      getData () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if ((this.$route.params.id !== undefined && this.$route.params.id) ||
          (this.id !== undefined && this.id !== null)) {
          this.isNew = false
        } else {
          this.isNew = true
        }
        if (!this.isNew) {
          var id = this.$route.params.id || this.id
          this.apiRequest('/payment-group/' + id, 'GET', data, (response) => {
            if (response.status === true) {
              this.model = response.data
              if (this.model.gateway === 'btIpay') {
                this.$set(this.model, 'bt_ipay_data', btSettings(this.model.bt_ipay_data || {}))
              }
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveZone() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      changeGateway () {
        this.btFormError = ''
        if (this.model.gateway === 'btIpay' && !this.model.bt_ipay_data) {
          this.$set(this.model, 'bt_ipay_data', btSettings())
        }
        if (this.model.gateway === 'paylike') {
          this.model.gateway_id = ''
          this.model.public_key = ''
          this.model.private_key = ''
          this.model.UKEY = ''
          this.model.UAPI = ''
        }
        if (this.model.gateway === 'euplatesc') {
          this.model.gateway_id = ''
          this.model.public_key = ''
          this.model.private_key = ''
          this.model.UKEY = ''
          this.model.UAPI = ''
        }
        if (this.model.gateway === 'stripe') {
          this.model.gateway_id = 'stripe'
          this.model.public_key = ''
          this.model.private_key = ''
          this.model.UKEY = ''
          this.model.UAPI = ''
        }
        if (this.model.gateway === 'vivaWallet') {
          this.model.gateway_id = 'vivaWallet'
          this.model.public_key = ''
          this.model.private_key = ''
          this.model.UKEY = ''
          this.model.UAPI = ''
        }
        if (this.model.gateway === 'libraPay') {
          this.model.gateway_id = 'libraPay'
          this.model.libra_pay_data = {
            merch_name: '',
            merch_url: '',
            email: '',
            key: '',
            merchant: '',
            terminal: '',
            postAction: 'https://secure.librapay.ro/pay_auth.php'
          }
        }
      },
      saveZone () {
        this.loading = true
        this.btFormError = ''
        let data = Object.assign({}, this.model)
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        data.group_name = this.model.group_name
        data.group_key = this.model.gateway === 'btIpay' && this.model.group_key ? this.model.group_key : this.model.group_name.toLowerCase().replace(/\s+/g, '') + '_' + data.company_id + '_' + new Date().getTime()
        data.gateway = this.model.gateway
        data.gateway_id = this.model.gateway_id
        data.public_key = this.model.public_key
        data.private_key = this.model.private_key
        data.UKEY = this.model.UKEY
        data.UAPI = this.model.UAPI
        data.libra_pay_data = this.model.libra_pay_data
        if (this.model.gateway === 'btIpay') {
          data.bt_ipay_data = Object.assign({}, this.model.bt_ipay_data)
          delete data.bt_ipay_data.has_api_password
          if (!data.bt_ipay_data.api_password) delete data.bt_ipay_data.api_password
        } else {
          delete data.bt_ipay_data
        }
        this.apiRequest('/payment-group/' + data.id, 'PUT', data, (response) => {
          if (response.success === true) {
            this.loading = false
            this.errors.clear()
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            .then(() => {})
            .catch(() => {})
            if (this.model.gateway === 'btIpay') this.model.bt_ipay_data.api_password = ''
            this.cancelZone()
          } else {
            this.loading = false
            if (this.model.gateway === 'btIpay') {
              this.btFormError = btApiError(response, this.$t('btPayments.saveError'))
            } else {
              this.handleErrors(response.errors)
            }
          }
        })
      },
      deleteZone () {
        var btnCounter = 3
        var self = this
        swal({
          title: 'Are you sure?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            this.deleteZone2()
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      deleteZone2 () {
        this.loadingReset = true
        var id = this.id || this.$route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/payment-group/' + id, 'PUT', data, (response) => {
          if (response.success === true) {
            this.loadingReset = false
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.cancelZone()
          } else {
            this.loadingReset = false
            swal({'text': this.model.gateway === 'btIpay' ? btApiError(response, this.$t('btPayments.saveError')) : this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      cancelZone () {
        if (typeof this.callback === 'function') {
          this.callback()
        }
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>
  /* secret hidden css start */



  /* secret hidden css stop */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/PaymentGroups/PaymentGroupsForm.vue